export const CartableRequestStatusCode = {
    CARTABLE_REQUEST_WAITING: 'در انتظار  تایید',
    CARTABLE_REQUEST_CONFIRMED: 'تایید شده', 
    CARTABLE_REQUEST_FINALIZED: 'نهایی شده', 
    CARTABLE_REQUEST_CANCELED: 'لغو شده', 
    CARTABLE_REQUEST_REJECTED: 'رد شده', 
    CARTABLE_REQUEST_FAILED: 'ناموفق', 
    CARTABLE_REQUEST_EXPIRED: 'منقضی شده',
    CARTABLE_REQUEST_WAIT_FOR_APPROVE: 'در انتظار تایید کننده نهایی',
    CARTABLE_REQUEST_FILE_PROCESS_START: 'در حال انجام فایل تراکنش گروهی',
}

export const isRequestCancelable = (reqStatus) => {
    switch (reqStatus) {
        case 'CARTABLE_REQUEST_CONFIRMED':
        case 'CARTABLE_REQUEST_WAIT_FOR_APPROVE':
        case 'CARTABLE_REQUEST_WAITING':
            return true;
        default:
            return false;
    }
}